import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { FC } from 'react'

interface Props {
  children: React.ReactElement
  style?: React.CSSProperties
}

const InfoTips: FC<Props> = (props) => {
  const {
    children,
    style,
  } = props

  return (
    <>
      <div
        style={{
          margin: "8px 8px 16px",
          color: "#666666",
          display: "flex",
          alignItems: "flex-start",
          gap: "4px",
          border: "solid 1px #6495ed",
          borderRadius: "4px",
          padding: "8px",
          backgroundColor: "#f0f8ff",
          ...style,
        }}
      >
        <FontAwesomeIcon icon={['fas', 'info-circle']} style={{ color: "#6495ed" }} />
        <div
          style={{
            display: "flex",
            flexFlow: "column",
            gap: "4px",
          }}
        >
          {children}
        </div>
      </div>
    </>
  )
}

InfoTips.defaultProps = {
  style: undefined,
}

export default InfoTips
